import React from "react";
import { useOrg } from "../../../auth/org-provider";
import { useColorScheme } from "../../../lib/color-scheme";
import { cn } from "../../../lib/utils";

export function OrgLogo(props: { className?: string }) {
    const org = useOrg();
    const { isDark } = useColorScheme();

    if (!org.logo) {
        return null;
    }

    return (
        <img
            alt={`${org.name} logo`}
            className={cn("h-10", props.className)}
            src={isDark ? org.logo.urlWhite : org.logo.urlBlack}
        />
    );
}
